<app-slim-topbar *ngIf="guest"></app-slim-topbar>
<div class="layout-content p-0 mb-5 mt-3" [ngClass]="layoutMarginResponsive()">
	<div *ngIf="guest" class="flex align-items-center justify-content-center w-full font-semibold text-2xl my-3">{{'BUS_PAGE_TITLE' | translate}}</div>
	<div class="card border-round">
		<div class="flex flex-row align-items-center justify-content-center my-3">
			<div class="flex flex-column">
				<div class="text-start">{{ 'BUS_SELECT_PANEL' | translate }} *</div>
				<div class="flex flex-row align-items-center gap-4">
					<p-dropdown [options]="listBus" [(ngModel)]= "busSelect" (onChange)="busChange()"
						class="w-15rem h-2rem" styleClass="w-15rem h-2rem">
						<ng-template let-item pTemplate="selectedItem">
							<div class="item" class="flex align-items-center justify-content-center">
								<div class="flex justify-content-center">{{ item.name }}</div>
							</div>
						</ng-template>
						<ng-template let-item pTemplate="item">
							<div class="item flex align-items-center justify-content-center">
								<div>{{ item.name }}</div>
							</div>
						</ng-template>
					</p-dropdown>
					<div>Cxn unit: {{busSelect.cxn}}</div>
				</div>
			</div>
		</div>

		<div [class]="(this.screenWidth <= MIN_WIDTH_COL4) ? 'grid mt-5' : 'flex flex-row w-full align-items-start justify-content-around mt-6'">
			<div [class]="(this.screenWidth <= MIN_WIDTH_COL4) ? (this.onMobileExt() ? 'col-12' : 'col-6') : 'flex flex-column gap-3'">
				<div class="flex flex-row justify-content-between">
					<div class="font-semibold text-xl">{{ 'BUS_PHOTOCELLS' | translate }}</div>
					<span class="mr-4" [ngClass]="{'text-50' : totalFotocellule === maxFotocellule}">max: {{totalFotocellule}}/{{maxFotocellule}}</span>
				</div>
				<div class="flex flex-column gap-3">
					<div class="flex flex-row align-items-center justify-content-between gap-8" *ngFor="let fotocellula of listFotocellule">
						<div class="flex flex-column justify-content-start">
							<span>{{ fotocellula.name | translate }}</span>
							<div class="text-sm" [class]="canAddAlertVisibleDevice(fotocellula) ? 'text-50' : ''">Cxn unit: {{fotocellula.cxn}}</div>
						</div>
						<div class="flex flex-row align-items-center gap-2">
							<p-button pTooltip="{{ 'SUBTRACT' | translate}}"
									[disabled]="fotocellula.disableRemove || checkSelectable(fotocellula)"
									tooltipPosition="bottom" icon="pi cm-minus" size="large"
									(click)="subtractOne(fotocellula)" [rounded]="false" [text]="true" severity="primary">
							</p-button>
							<strong>{{ fotocellula.quantity }}</strong>
							<p-button pTooltip="{{ 'ADD' | translate}}"
									[disabled]="fotocellula.disableAdd || checkSelectable(fotocellula)"
									tooltipPosition="bottom" icon="pi cm-plus" size="large"
									(click)="addOne(fotocellula)" [rounded]="false" [text]="true" severity="primary">
							</p-button>
						</div>
					</div>
				</div>
			</div>
			<div [class]="(this.screenWidth <= MIN_WIDTH_COL4) ? (this.onMobileExt() ? 'col-12' : 'col-6') : 'flex flex-column gap-3'">
				<div class="flex flex-row justify-content-between">
					<div class="font-semibold text-xl">{{ 'BUS_SELECTORS' | translate }}</div>
					<span class="mr-4" [ngClass]="{'text-50' : totalSelettori === maxSelettori}">max: {{totalSelettori}}/{{maxSelettori}}</span>
				</div>
				<div class="flex flex-column gap-3">
					<div class="flex flex-row align-items-center justify-content-between gap-8" *ngFor="let selettore of listSelettori">
						<div class="flex flex-column justify-content-start">
							<span>{{ selettore.name | translate }}</span>
							<div class="text-sm" [class]="canAddAlertVisibleDevice(selettore) ? 'text-50' : ''">Cxn unit: {{selettore.cxn}}</div>
						</div>
						<div class="flex flex-row align-items-center gap-2">
							<p-button pTooltip="{{ 'SUBTRACT' | translate}}"
									[disabled]="selettore.disableRemove || checkSelectable(selettore)"
									tooltipPosition="bottom" icon="pi cm-minus" size="large"
									(click)="subtractOne(selettore)" [rounded]="false" [text]="true" severity="primary">
							</p-button>
							<strong>{{ selettore.quantity }}</strong>
							<p-button pTooltip="{{ 'ADD' | translate}}"
									[disabled]="selettore.disableAdd || checkSelectable(selettore)"
									tooltipPosition="bottom" icon="pi cm-plus" size="large"
									(click)="addOne(selettore)" [rounded]="false" [text]="true" severity="primary">
							</p-button>
						</div>
					</div>
				</div>
			</div>
			<div [class]="(this.screenWidth <= MIN_WIDTH_COL4) ? (this.onMobileExt() ? 'col-12' : 'col-6') : 'flex flex-column gap-3'">
				<div class="flex flex-row justify-content-between">
					<div class="font-semibold text-xl">{{ 'BUS_INTERFACES' | translate }}</div>
					<span class="mr-4" [ngClass]="{'text-50' : totalInterfaccie === maxInterfaccie}">max: {{totalInterfaccie}}/{{maxInterfaccie}}</span>
				</div>
				<div class="flex flex-column gap-3">
					<div class="flex flex-row align-items-center justify-content-between gap-8" *ngFor="let interfaccia of listInterfaccie">
						<div class="flex flex-column justify-content-start">
							<span>{{ interfaccia.name | translate }}</span>
							<div class="text-sm" [class]="canAddAlertVisibleDevice(interfaccia) ? 'text-50' : ''">Cxn unit: {{interfaccia.cxn}}</div>
						</div>
						<div class="flex flex-row align-items-center gap-2">
							<p-button pTooltip="{{ 'SUBTRACT' | translate}}"
									[disabled]="interfaccia.disableRemove || checkSelectable(interfaccia)"
									tooltipPosition="bottom" icon="pi cm-minus" size="large"
									(click)="subtractOne(interfaccia)" [rounded]="false" [text]="true" severity="primary">
							</p-button>
							<strong>{{ interfaccia.quantity }}</strong>
							<p-button pTooltip="{{ 'ADD' | translate}}"
									[disabled]="interfaccia.disableAdd || checkSelectable(interfaccia)"
									tooltipPosition="bottom" icon="pi cm-plus" size="large"
									(click)="addOne(interfaccia)" [rounded]="false" [text]="true" severity="primary">
							</p-button>
						</div>
					</div>
				</div>
			</div>
			<div [class]="(this.screenWidth <= MIN_WIDTH_COL4) ? (this.onMobileExt() ? 'col-12' : 'col-6') : 'flex flex-column gap-3'">
				<div class="flex flex-row justify-content-between">
					<div class="font-semibold text-xl">{{ 'BUS_FLASHING' | translate }}</div>
					<span class="mr-4" [ngClass]="{'text-50' : totalLampeggianti === maxLampeggianti}">max: {{totalLampeggianti}}/{{maxLampeggianti}}</span>
				</div>
				<div class="flex flex-column gap-3">
					<div class="flex flex-row align-items-center justify-content-between gap-8" *ngFor="let lampeggiante of listLampeggianti">
						<div class="flex flex-column justify-content-start">
							<span>{{ lampeggiante.name | translate }}</span>
							<div class="text-sm" [class]="canAddAlertVisibleDevice(lampeggiante) ? 'text-50' : ''">Cxn unit: {{lampeggiante.cxn}}</div>
						</div>
						<div class="flex flex-row align-items-center gap-2">
							<p-button pTooltip="{{ 'SUBTRACT' | translate}}"
									[disabled]="lampeggiante.disableRemove || checkSelectable(lampeggiante)"
									tooltipPosition="bottom" icon="pi cm-minus" size="large"
									(click)="subtractOne(lampeggiante)" [rounded]="false" [text]="true" severity="primary">
							</p-button>
							<strong>{{ lampeggiante.quantity }}</strong>
							<p-button pTooltip="{{ 'ADD' | translate}}"
									[disabled]="lampeggiante.disableAdd || checkSelectable(lampeggiante)"
									tooltipPosition="bottom" icon="pi cm-plus" size="large"
									(click)="addOne(lampeggiante)" [rounded]="false" [text]="true" severity="primary">
							</p-button>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div [class]="(this.screenWidth <= MIN_WIDTH_COL4) ? 'grid my-5' : 'flex flex-row w-full align-items-start justify-content-center mt-8 mb-5'">
			<div [class]="(this.screenWidth <= MIN_WIDTH_COL4) ? (this.onMobileExt() ? 'col-12' : 'col-6') : 'flex flex-column mt-5 mr-6'">
				<div [class]="(this.screenWidth <= MIN_WIDTH_COL4) ? 'flex flex-row align-items-center justify-content-center mb-2' : 'flex flex-row align-items-center'">
					<div class="w-11rem mr-2 text-xl font-semibold">{{ 'BUS_TOTAL_LOAD' | translate }}</div>
					<div class="flex flex-row">
						<div class="w-4rem flex justify-content-center text-xl font-semibold">(q.)</div>
						<div class="w-4rem flex justify-content-center text-xl font-semibold">(cxn)</div>
					</div>
				</div>
				<div [class]="(this.screenWidth <= MIN_WIDTH_COL4) ? 'flex flex-row align-items-center justify-content-center mb-2' : 'flex flex-row align-items-center mt-3'">
					<!-- <div class="w-1rem h-2rem bg-yellow-600 border-round-lg"></div> -->
					<div class="w-1rem h-2rem border-round-lg" style="background-color: orange;"></div>
					<div class="ml-2 w-10rem text-lg">{{ 'BUS_PHOTOCELLS' | translate }}</div>
					<div class="flex flex-row">
						<div class="w-4rem flex justify-content-center text-lg">{{totalFotocellule}}</div>
						<div class="w-4rem flex justify-content-center text-lg">{{totalLoadFotocellulePercentage}} %</div>
					</div>
				</div>
				<div [class]="(this.screenWidth <= MIN_WIDTH_COL4) ? 'flex flex-row align-items-center justify-content-center mb-2' : 'flex flex-row align-items-center mt-2'">
					<!-- <div class="w-1rem h-2rem bg-green-600 border-round-lg"></div> -->
					<div class="w-1rem h-2rem border-round-lg" style="background-color: green;"></div>
					<div class="ml-2 w-10rem text-lg">{{ 'BUS_SELECTORS' | translate }}</div>
					<div class="flex flex-row">
						<div class="w-4rem flex justify-content-center text-lg">{{totalSelettori}}</div>
						<div class="w-4rem flex justify-content-center text-lg">{{totalLoadSelettoriPercentage}} %</div>
					</div>
				</div>
				<div [class]="(this.screenWidth <= MIN_WIDTH_COL4) ? 'flex flex-row align-items-center justify-content-center mb-2' : 'flex flex-row align-items-center mt-2'">
					<!-- <div class="w-1rem h-2rem bg-blue-600 border-round-lg"></div> -->
					<div class="w-1rem h-2rem border-round-lg" style="background-color: blue;"></div>
					<div class="ml-2 w-10rem text-lg">{{ 'BUS_INTERFACES' | translate }}</div>
					<div class="flex flex-row">
						<div class="w-4rem flex justify-content-center text-lg">{{totalInterfaccie}}</div>
						<div class="w-4rem flex justify-content-center text-lg">{{totalLoadInterfacciePercentage}} %</div>
					</div>
				</div>
				<div [class]="(this.screenWidth <= MIN_WIDTH_COL4) ? 'flex flex-row align-items-center justify-content-center mb-2' : 'flex flex-row align-items-center mt-2'">
					<!-- <div class="w-1rem h-2rem bg-purple-600 border-round-lg"></div> -->
					<div class="w-1rem h-2rem border-round-lg" style="background-color: pink;"></div>
					<div class="ml-2 w-10rem text-lg">{{ 'BUS_FLASHING' | translate }}</div>
					<div class="flex flex-row">
						<div class="w-4rem flex justify-content-center text-lg">{{totalLampeggianti}}</div>
						<div class="w-4rem flex justify-content-center text-lg">{{totalLoadLampeggiantiPercentage}} %</div>
					</div>
				</div>
				<div [class]="(this.screenWidth <= MIN_WIDTH_COL4) ? 'flex flex-row align-items-center justify-content-center' : 'flex flex-row align-items-center mt-3'">
					<div class="w-11rem mr-2 text-xl font-semibold">{{ 'TOTAL' | translate }} {{ 'BUS' | translate }}</div>
					<div class="flex flex-row">
						<div class="w-4rem flex justify-content-center text-xl font-semibold">{{totalFotocellule + totalSelettori + totalInterfaccie + totalLampeggianti}}</div>
						<div class="w-4rem flex justify-content-center text-xl font-semibold">{{totalLoadBusPercentage}} %</div>
					</div>
				</div>
			</div>
			<div [class]="(this.screenWidth <= MIN_WIDTH_COL4) ? (this.onMobileExt() ? 'col-12' : 'col-6') : 'flex flex-column w-30rem'">
				<div [class]="(this.screenWidth <= MIN_WIDTH_COL4) ? 'flex flex-row justify-content-center' : 'flex flex-row justify-content-end'">
					<p-chart
						#busCalculation
						type="doughnut"
						[data]="totalChart"
						[options]="totalOptions"
						[responsive]="true"
						[style]="{ width: '70%' }">
					</p-chart>
				</div>
			</div>
		</div>
	</div>
</div>
<app-common-footer *ngIf="guest"></app-common-footer>